'use client'

import { Root } from '@radix-ui/react-hover-card'
import type { ComponentProps } from 'react'

export type HoverCardProps = ComponentProps<typeof Root>

export function HoverCard(props: HoverCardProps) {
  return <Root {...props} />
}
